import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.authCallback,
	components: () => [import(/* webpackChunkName: 'authCallback' */ './component')],
	render: ([AuthCallback]) => <AuthCallback />,
};

export default routes;
